<template>
    <div id="anchorageWizard" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false"
        aria-labelledby="anchorageWizardTitle" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content wizard-content">
                <div class="modal-header wizard-header">
                    <h5 class="modal-title wizard-title" id="anchorageWizardTitle">
                        Anchorage Wizard
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body wizard-body">
                    <div class="step-main">
                        <div class="btn-group" role="group">
                            <button id="btnMaxilla1" type="button" v-bind:class="{ 'dentition-selected': isMaxilla1 }"
                                v-on:click="switchDentition1Click(true)" class="btn btn-light">
                                MAXILLA
                            </button>
                            <button id="btnMandible1" type="button" v-bind:class="{ 'dentition-selected': !isMaxilla1 }"
                                v-on:click="switchDentition1Click(false)" class="btn btn-light">
                                MANDIBULAR
                            </button>
                        </div>
                        <div id="anchorage1" class="anchorage-step" v-on:click="switchAnchorageStepClick(true)"
                            v-bind:class="{ 'anchorage-selected': isAnchorageStep1 }">
                            <div class="step-description">
                                Anchorage 1: Select teeth for anchorage (one or several)
                            </div>
                            <div class="stl-group">
                                <div id="anchorage1Viewer" class="anchorage-viewer">
                                </div>
                                <img class="anchorage-spinner centered-spinner" src="images/dark-blue-spinner.gif" />
                            </div>
                        </div>
                        <div class="btn-group btn-group2" role="group">
                            <button id="btnMaxilla2" type="button" v-bind:class="{ 'dentition-selected': isMaxilla2 }"
                                v-on:click="switchDentition2Click(true)" class="btn btn-light">
                                MAXILLA
                            </button>
                            <button id="btnMandible2" type="button" v-bind:class="{ 'dentition-selected': !isMaxilla2 }"
                                v-on:click="switchDentition2Click(false)" class="btn btn-light">
                                MANDIBULAR
                            </button>
                        </div>
                        <div id="anchorage2" class="anchorage-step" v-on:click="switchAnchorageStepClick(false)"
                            v-bind:class="{ 'anchorage-selected': !isAnchorageStep1 }">
                            <div class="step-description">
                                Anchorage 2: Select opposing teeth for anchorage (one or several)
                            </div>
                            <div class="stl-group">
                                <div id="anchorage2Viewer" class="anchorage-viewer">
                                </div>
                                <img class="anchorage-spinner centered-spinner" src="images/dark-blue-spinner.gif" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer wizard-footer">
                    <button type="button" class="btn btn-primary btn-next" v-on:click="generateReportClick()">
                        Generate Report
                    </button>
                </div>
                <img id="anchorageSpinner" class="anchorage-spinner" src="images/dark-blue-spinner.gif" />
            </div>
        </div>
    </div>
</template>

<script>

import {
    switchToMaxilla1,
    switchToMandibular1,
    switchToMaxilla2,
    switchToMandibular2,
    generateAnchorageReport
} from "@/components/anchorage/AnchorageMode.js";

export default {
    name: "AnchorageWizard",
    props: [],
    data() {
        return {
            isMaxilla1: true,
            isMaxilla2: true,
            isAnchorageStep1: true
        };
    },
    methods: {
        switchAnchorageStepClick: function (value) {
            if (this.isAnchorageStep1 != value) {
                this.isAnchorageStep1 = value;
            }
        },
        switchDentition1Click: function (value) {
            if (this.isMaxilla1 != value) {
                this.isMaxilla1 = value;
                if (this.isMaxilla1) {
                    switchToMaxilla1();
                } else {
                    switchToMandibular1();
                }
            }
        },
        switchDentition2Click: function (value) {
            if (this.isMaxilla2 != value) {
                this.isMaxilla2 = value;
                if (this.isMaxilla2) {
                    switchToMaxilla2();
                } else {
                    switchToMandibular2();
                }
            }
        },
        generateReportClick: function () {
            generateAnchorageReport();
        }
    }
};
</script>

<style scoped>
@import "../../css/wizard.css";

.modal-dialog {
    max-width: 600px;
    max-height: 100%;
}

.modal-content {
    max-height: 100vh;
}

.modal-title {
    max-width: 300px;
    width: 200px;
    left: calc(50% - 95px);
    font-size: 1rem;
}

.modal-body {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 5px;
}

.modal-header {
    padding: 0.4rem 0.5rem 0.3rem 0.5rem;
}

.modal-header .close {
    padding: 0.4rem;
    margin: -0.4rem -0.4rem -0.6rem auto;
}

.step-main {
    /* margin-top: 15px; */
    text-align: center;
}

.btn {
    border-radius: 0px;
    border: 1px solid #000000;
    width: 170px;
    font-size: 0.8rem;
    padding: .2rem .5rem;
}

.btn-next {
    height: auto;
}

.btn-group2 {
    margin-top: 15px;
}

.step-description {
    text-align: center;
    color: #0069d9;
    margin-top: 5px;
    font-size: 0.8rem;
}

.dentition-selected {
    background-color: #77a7fd;
    /* #deeaf6; */
}

.stl-group {
    margin-top: 5px;
    height: 300px;
    max-height: 25vh;
    width: 100%;
    position: relative;
    cursor: pointer;
}

/* @media (max-height: 600px) {
    .stl-group {
        height: 250px;
    }
} */

.anchorage-viewer {
    background-color: #082F5E;
    /* #082F5E; */
    position: absolute;
    width: 100%;
    height: 100%;
}

.anchorage-spinner {
    position: absolute;
    display: none;
    width: 100px;
    height: 100px;
    left: calc(50% - 50px);
    top: 405px;
    text-align: center;
    z-index: 9;
}
</style>
